import React from 'react';
type BookStackProps = {
  className?: string;
};
export function BookStack({
  className = ''
}: BookStackProps) {
  return <div className={`mx-auto w-full max-w-[860px] ${className}`} data-id="element-37" data-mp="2i959chcg0igs">
      <img src="https://cdn.magicpatterns.com/uploads/oRndFGhGEorVbuXiRu179L/Imagen_de_ChatGPT_27_sept_2026,_11_52_07_a.m..png" alt="Megapack Maestro de Sesiones: módulos en espiral junto a tablet, computadora y celular mostrando el material digital" className="h-auto w-full mix-blend-multiply" width={1536} height={1024} data-id="element-38" data-mp="23m3o6457x7mw" />
    </div>;
}